import { Howl } from 'howler';

export const bellSound = new Howl({
  src: ['bell-2.mp3'],
  loop: true,
});
